module.exports = __webpack_public_path__ + "7c4718a69ed926124e4e013b106f1070.eot";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Bold.eot
// module id = 404
// module chunks = 0